import { MiddleWareGetApi, DashboardApi as AuthGetApi, MiddleWarePostApi, ZendeskPostApi } from '../services/apiService';
import { EncryptText, DecryptText } from '../services/EncDecService';

/**
 * Universal SWR Fetcher
 * Handles different Base URLs and HTTP Methods.
 */
export const swrFetcher = async (args) => {
  // Simple String Key (MW GET)
  if (typeof args === 'string') {
    const res = await MiddleWareGetApi(args);
    return res.data;
  }

  // Array Key (Complex)
  if (Array.isArray(args)) {
    // Find if any element defines the service type (mw_post, auth, etc.)
    const serviceType = args.find(a => ['mw_post', 'mw_post_plain', 'zendesk', 'auth', 'mw'].includes(a)) || 'mw';
    const url = args[args.length - 1]; // URL is usually last (except for POST with body)

    // --- MiddleWare POST with Encryption ---
    if (serviceType === 'mw_post') {
      const mwPostIdx = args.indexOf('mw_post');
      const actualUrl = args[mwPostIdx + 1];
      const body = args[mwPostIdx + 2] || {};

      const encryptedReq = await EncryptText(body);
      const res = await MiddleWarePostApi(actualUrl, encryptedReq);
      if (!res) return null; // session-expired handled by apiService/checkTokenExpiry

      if (res.statusCode === 0 || res.statusCode === '0' || res.statusCode === '200') {
        if (res.userDetails) {
          const decrypted = await DecryptText(res.userDetails);
          // Return the full response but with decrypted userDetails
          return { ...res, userDetails: decrypted };
        }
        const decrypted = await DecryptText(res.data);
        return decrypted;
      }

      const error = new Error(res.statusDesc || 'API Error');
      error.status = res.statusCode;
      error.info = res;
      throw error;
    }

    // --- MiddleWare POST (Plain) ---
    if (serviceType === 'mw_post_plain') {
      const mwPostIdx = args.indexOf('mw_post_plain');
      const actualUrl = args[mwPostIdx + 1];
      const body = args[mwPostIdx + 2] || {};

      const res = await MiddleWarePostApi(actualUrl, body);
      if (!res) return null;

      if (res.statusCode === 0 || res.statusCode === '0' || res.statusCode === '200') {
        return res.data;
      }

      const error = new Error(res.statusDesc || 'API Error');
      error.status = res.statusCode;
      error.info = res;
      throw error;
    }

    // --- Zendesk POST ---
    if (serviceType === 'zendesk') {
      const zendeskIdx = args.indexOf('zendesk');
      const actualUrl = args[zendeskIdx + 1];
      const body = args[zendeskIdx + 2] || {};

      const res = await ZendeskPostApi(actualUrl, body);
      if (!res) return null;

      if (res.statusCode === 0 || res.statusCode === '0' || res.statusCode === '200') {
        return res.data;
      }

      const error = new Error(res.statusDesc || 'API Error');
      error.status = res.statusCode;
      error.info = res;
      throw error;
    }

    // --- Services Selection ---
    let service = MiddleWareGetApi;
    if (serviceType === 'auth') service = AuthGetApi;
    if (serviceType === 'mw') service = MiddleWareGetApi;

    const res = await service(url);
    if (!res) return null;

    const successCode = res.statusCode ?? res.status;
    if (successCode !== '200' && successCode !== 0 && successCode !== '0' && successCode !== 200) {
      const error = new Error(res.message || res.statusDesc || 'API Error');
      error.status = successCode;
      error.info = res;
      throw error;
    }
    return res.data ?? res;
  }

  throw new Error('Invalid SWR Key Format');
};
